import { CONTACT_SENTIMENT } from 'utils/enums';

export const CONTACT_PREVIEWS = [
  {
    type: CONTACT_SENTIMENT.NEGATIVE,
    issue: 'Bất hợp tác, thô tục/ công kích, ngắt lời',
    solution:
      'Nhân viên hỗ trợ cần giữ bình tĩnh, lịch sự và chuyên nghiệp trong mọi tình huống. Nếu khách hàng trở nên thô tục hoặc công kích, nhân viên nên cố gắng chuyển hướng cuộc trò chuyện sang các vấn đề cụ thể liên quan đến dịch vụ hoặc sản phẩm. Nếu khách hàng tiếp tục ngắt lời hoặc không hợp tác, nhân viên có thể đề nghị kết thúc cuộc trò chuyện và mời khách hàng liên hệ lại khi họ sẵn sàng hợp tác.'
  },
  {
    type: CONTACT_SENTIMENT.POSITIVE,
    issue: 'Khách hàng vui vẻ, hài lòng với dịch vụ',
    solution:
      'Nhân viên hỗ trợ nên thể hiện sự đánh giá cao và cảm ơn khách hàng vì sự hài lòng của họ. Họ có thể hỏi thêm về trải nghiệm của khách hàng và lắng nghe phản hồi để cải thiện dịch vụ trong tương lai. Ngoài ra, nhân viên có thể đề xuất các sản phẩm hoặc dịch vụ bổ sung mà khách hàng có thể quan tâm, nhằm tăng cường mối quan hệ và tạo cơ hội bán hàng trong tương lai.'
  },
  {
    type: CONTACT_SENTIMENT.NEGATIVE,
    issue: 'Yêu cầu vượt quá khả năng/ thẩm quyền của nhân viên hỗ trợ',
    solution:
      'Nhân viên hỗ trợ nên lắng nghe và hiểu rõ yêu cầu của khách hàng trước khi phản hồi. Nếu yêu cầu vượt quá khả năng hoặc thẩm quyền của nhân viên, họ nên giải thích một cách lịch sự và rõ ràng về giới hạn của mình. Nhân viên có thể đề xuất các giải pháp thay thế hoặc hướng dẫn khách hàng liên hệ với bộ phận hoặc cá nhân có thẩm quyền phù hợp để giải quyết yêu cầu của họ.'
  },
  {
    type: CONTACT_SENTIMENT.POSITIVE,
    issue: 'Khách hàng vui vẻ, hài lòng với dịch vụ',
    solution:
      'Nhân viên hỗ trợ nên thể hiện sự đánh giá cao và cảm ơn khách hàng vì sự hài lòng của họ. Họ có thể hỏi thêm về trải nghiệm của khách hàng và lắng nghe phản hồi để cải thiện dịch vụ trong tương lai. Ngoài ra, nhân viên có thể đề xuất các sản phẩm hoặc dịch vụ bổ sung mà khách hàng có thể quan tâm, nhằm tăng cường mối quan hệ và tạo cơ hội bán hàng trong tương lai.'
  }
];
